import React, { ReactElement } from 'react'
import { Placement } from '@elamajs/ui-kit'
import Field from './_Field'
import { ParametersData } from '@src/data/UtmGenerator'
import { useHTTPContext } from '@src/containers/UtmGenerator/context'
import { useWindowWidth } from '@src/containers/UtmGenerator/hooks'
import { transformInputInfo } from '@src/containers/UtmGenerator/helpers/_transformInputIfmo'

import * as Styled from './Parameters.styled'

function Parameters(): ReactElement {
  const [width] = useWindowWidth()
  const { traffic } = useHTTPContext()

  return (
    <Styled.Body>
      <Styled.Column>
        <Styled.Title>Обязательные параметры</Styled.Title>
        <Styled.Grid>
          {ParametersData.required.map(item => (
            <Field
              key={item.id}
              title={item.title}
              text={item.text}
              tooltipContent={item.tooltipContent}
              tooltipDirection={
                width > 1279 ? 'right-start' : (item.tooltipDirectionMob as Placement)
              }
              inputInfo={transformInputInfo(item.inputInfo, traffic)}
              tooltipWidth={width > 999 ? item.tooltipWidth : '260px'}
              fieldName={item.fieldName}
            />
          ))}
        </Styled.Grid>
      </Styled.Column>
      <Styled.Column>
        <Styled.Title>Дополнительные параметры</Styled.Title>
        <Styled.Grid>
          {ParametersData.optional.map(item => (
            <Field
              key={item.id}
              title={item.title}
              text={item.text}
              tooltipDirection={
                width > 1279 ? 'left-start' : (item.tooltipDirectionMob as Placement)
              }
              tooltipContent={item.tooltipContent}
              tooltipWidth={width > 999 ? item.tooltipWidth : '260px'}
              inputInfo={transformInputInfo(item.inputInfo, traffic)}
              fieldName={item.fieldName}
            />
          ))}
        </Styled.Grid>
      </Styled.Column>
    </Styled.Body>
  )
}

export default Parameters
